// extracted by mini-css-extract-plugin
var _1 = "ToggleItem__circle--KK6ZV";
var _2 = "ToggleItem__main--wAoJc";
var _3 = "ToggleItem__off--DiWGA ToggleItem__main--wAoJc";
var _4 = "ToggleItem__on--y6eub ToggleItem__main--wAoJc";
var _5 = "ToggleItem__text--IY_lo OfficeGeneral__roboto--WQooW CoreGeneral__roboto--UlmjE";
var _6 = "ToggleItem__textOff--vt9Jx ToggleItem__text--IY_lo OfficeGeneral__roboto--WQooW CoreGeneral__roboto--UlmjE";
var _7 = "ToggleItem__textOn--PWc22 ToggleItem__text--IY_lo OfficeGeneral__roboto--WQooW CoreGeneral__roboto--UlmjE";
export { _1 as "circle", _2 as "main", _3 as "off", _4 as "on", _5 as "text", _6 as "textOff", _7 as "textOn" }
